import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";

// Recover from stale cached chunks after a new deploy: reload once.
const RELOAD_KEY = "chunk-reload-at";
const reloadOnce = () => {
  const last = Number(sessionStorage.getItem(RELOAD_KEY) || 0);
  if (Date.now() - last > 10000) {
    sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
    window.location.reload();
  }
};

window.addEventListener("vite:preloadError", (e) => {
  e.preventDefault();
  reloadOnce();
});

// A stale cached chunk can resolve to an empty module, which surfaces as
// "Cannot read properties of undefined (reading 'default')" and a blank screen.
window.addEventListener("error", (e) => {
  const msg = String(e.message || "");
  if (
    msg.includes("reading 'default'") ||
    msg.includes("Failed to fetch dynamically imported module") ||
    msg.includes("error loading dynamically imported module")
  ) {
    reloadOnce();
  }
});

window.addEventListener("unhandledrejection", (e) => {
  const msg = String(e.reason?.message || e.reason || "");
  if (msg.includes("Failed to fetch dynamically imported module") || msg.includes("error loading dynamically imported module")) {
    reloadOnce();
  }
});



createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
